import { ROUTES, TITLES, STAGE, DEV, PROD } from 'consts';

export const UPLOADING_PLAN_MENU = {
  key: ROUTES.UPLOADING_PLAN.ROOT,
  label: TITLES[ROUTES.UPLOADING_PLAN.ROOT],
  environment: [DEV, STAGE, PROD],
  children: [
    {
      key: ROUTES.UPLOADING_PLAN.APARTMENTS,
      label: TITLES[ROUTES.UPLOADING_PLAN.APARTMENTS],
      environment: [DEV, STAGE, PROD],
    },
  ],
};
